exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".review-container .r-slideout--content{padding:0!important}.review-container .close{border-radius:5px}.disabled{position:relative;pointer-events:none;opacity:.6}.form-section-review{background:none;-webkit-box-shadow:none;box-shadow:none;padding-left:30px;padding-bottom:0}.update-info{margin:0}.btn--primary.btn--solid{display:inline-block}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-004b45ff","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/applicants/FailureNotes.vue
// module id = edWY
// module chunks = 0 1